// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./EditMenuSettings.RearrangeSections.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import {
  RootPrimitive,
  TextPrimitive,
  ContainerPrimitive,
} from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      MWMunu2ivg: {
        none: {
          text: "Arrange Menu Sections",
        },
      },
    },
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const RearrangeSectionsContext = createContext(null);

function RearrangeSections(_props) {
  const defaults = useContext(RearrangeSectionsContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="EDZfNKRjpE"
      addSpacing={true}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "EDZfNKRjpE",
        scope: "MzgwatzHVq",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <>
          <TextPrimitive
            id={"Text_MWMunu2ivg"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_MzgwatzHVq_MWMunu2ivg"
            }
            key={"MWMunu2ivg"}
            text={getStyle("MWMunu2ivg", "text")}
            element={getStyle("MWMunu2ivg", "htmlElement")}
          />
          <ContainerPrimitive
            key={"7V6S4u58Z5"}
            id={"Slot_7V6S4u58Z5"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_MzgwatzHVq_7V6S4u58Z5"
            }
            addSpacing={false}
          >
            {props.children}
          </ContainerPrimitive>
        </>
      )}
    </RootPrimitive>
  );
}

RearrangeSections.__variants = [];

export default RearrangeSections;
